import { Button, Modal, ModalContent, ModalFooter } from "monday-ui-react-core"

const UploadErrorModalComponent = ({showModal, closeModal, csvErrors}) => {
    return (
        <Modal
            id="errors-modal"
            onClose={closeModal}
            show={showModal}
            title={'File could not be uploaded'}
        >
            <ModalContent>
                <p className='fw-bold'>Please fix the following errors in the file and upload it again.</p>
                <div className='error-container'>
                    {
                        csvErrors.length && csvErrors.map((csv, i) => {
                            let reportingCenter = csv?.reportingCenter != null && csv?.reportingCenter !== "" ?
                                <p>Reporting Center: {csv.reportingCenter}</p>
                                : ""
                            let reportingMonth = csv?.reportingMonth !== null && csv?.reportingMonth !== "" ?
                                <p>Reporting Month: {csv.reportingMonth}</p>
                                : ""
                            let senderNumber = csv?.senderNumber != null && csv?.senderNumber !== "" ?
                                <p>Sender Number: {csv.senderNumber}</p>
                                : ""

                            return (
                                <div className='error-item' key={i}>
                                    {reportingCenter}
                                    {reportingMonth}
                                    {senderNumber}
                                    <ul>
                                        {csv.errors.map(item => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                    {csvErrors.length > 1 ? <hr class="bg-dark border-2 border-top border-dark"/> : ""}
                                </div>
                            )
                        })         
                    }
                </div>
            </ModalContent>
            <ModalFooter>
                <div className="d-flex justify-content-end align-items-center">
                    <Button
                        onClick={closeModal}
                        className="cancel-modal-button"
                    >
                        Close
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default UploadErrorModalComponent